export default [
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'subject',
        name: 'SubjectInfo',
        beforeEnter: (to, from, next) => {
            const token = to.query.token;
            if (!token) {
                next('/'); // ❌ 토큰 없음
                return;
            }
            const raw = localStorage.getItem(`subject-token-${token}`) || sessionStorage.getItem(`subject-token-${token}`);
            if (!raw) {
                next('/'); // ❌ 토큰에 해당하는 정보 없음
                return;
            }

            // ✅ 토큰이 있고 데이터도 있으면 진입 허용
            next();
        },
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/SubjectInfo.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'screening',
        name: 'ResultScreening',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Screening.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'visit',
        name: 'ResultVisit',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Visit.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'specimen',
        name: 'ResultSpecimen',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Specimen.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'coMedi',
        name: 'CoMedication',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Comedication.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'adverseEvent',
        name: 'AdverseEvent',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/AdverseEvent.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'response',
        name: 'Response',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Response.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'eos',
        name: 'EOS',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/EOS.vue"),
    },
    {
        path: 'diseaseStatusResponse',
        name: 'DiseaseStatusResponse',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/DiseaseStatusResponse.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'audit',
        name: 'Audit',
        meta: { requiresAuth: true },
        component: () => import("../form/resultEntry/Audit.vue"),
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'query',
        name: 'SubjectQuery',
        meta: { requiresAuth: true },
        component: () => import("../form/user/Query.vue"),
    },
]